export default __webpack_public_path__ + "static/media/hazards_vehicle.e484f95c.svg";